import { gql } from "@apollo/client";

export const REFERENCES_CRUD_MUTATION = gql`
  mutation updateGroupText($scenarioId: ID!, $originId: ID!, $input: EditGroupTextsInput) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      editGroupTexts(input: $input) {
        commited
        group {
          id
          code
          label
          name
          capacity
          type
          text
          references {
            id
            value
            referenceCategory {
              code
            }
          }
          clientCode
          visibleForEnrollment
          term {
            code
            id
            name
            start_date
            end_date
            __typename
          }
          course {
            code
            name
            tags
            curriculum {
              id
              name
              program {
                id
                code
                campus {
                  id
                  code
                  name
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          customFields {
            id
            value
            code
            __typename
          }
          links {
            id
            vacancies
            code
            bundle {
              id
              code
              label
              name
              capacity
              __typename
            }
            __typename
          }
          enrollmentStats {
            id
            enrollmentsCount
            waitingListsCount
            __typename
          }
          labels {
            id
            code
            name
            category {
              id
              code
              name
              labelSource {
                id
                code
                name
                __typename
              }
              __typename
            }
            __typename
          }
          totalBlocks
          totalBlocksWithInstructors
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
